import React from 'react'
import { Link } from 'react-router-dom'
import { Typography, Tabs, Row, Col, Form, Input, Switch, DatePicker, TimePicker, Icon, Button, Modal, Checkbox, Select } from 'antd'
import { Queries } from '../../../../graphql'
import { withApollo } from 'react-apollo'
import moment from 'moment';
import Container from '../../../../components/user/Container'
import AddMeeting from '../../../../components/user/from/MeetingManagement/AddMeeting'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'


const { Option } = Select;
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Search } = Input;
const { Text, Title } = Typography
const dateFormat = ['DD/MM/YYYY'];
const timeFormat = 'HH:mm';
class CreateMeetingFormWithApprove extends React.Component {

    state = {
        showModalSelectAprover: false,
        showModalConfirm: false,
        textModalSuccess: '',
        showModalSuccess: false,
        approverList: [],
        approverSelect: [],
        selectApprover: [],
    }

    componentDidMount = async () => {

        this.setState({
            approverList: [{
                id: "1",
                name: "นางสาว ธนพร  สิริโสภา",
                select: false,
            }, {
                id: "2",
                name: "นางสาว ชิดชนก  จิรวราพงศ์",
                select: false,
            }, {
                id: "3",
                name: "นาง นวมล  ภัททกิจโภคิน์",
                select: false,
            }, {
                id: "4",
                name: "นาง ดรัลพร  จิรอรรถธาดา",
                select: false,
            }],
        })
    }

    handleCancel = () => {
        this.setState({
            showModalSelectAprover: false,
            showModalSuccess: false,
            showModalConfirm: false,
        })
    }

    handleOpen = () => {
        this.setState({
            showModalSelectAprover: true
        })
    }
    sentApprover = () => {
        this.setState({
            showModalConfirm: true
        })
    }
    handleOk = async () => {
        await this.setState({
            textModalSuccess: 'ส่งคำขออนุมัติการประชุมเรียบร้อย',
            showModalConfirm: false,
            showModalSuccess: true,
        })
        setTimeout(async () => {
            this.handleCancel();
        }, 1000);
    }
    handleOkapproverList = () => {
        this.setState({
            textModalSuccess: 'เลือกผู้อนุมัติการประชุมสำเร็จ',
            showModalSelectAprover: false,
            showModalSuccess: true,
        })
        setTimeout(() => {
            this.setState({
                showModalSuccess: false
            })
        }, 1000);
    }
    onCheckAddInternal = (e) => {
        if (e.target.checked) {
            let tempValue = [...this.state.selectApprover, e.target.value];
            this.setState({
                selectApprover: tempValue
            })
        } else {
            var array = [...this.state.selectApprover];
            var index = array.indexOf(e.target.value)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selectApprover: array });
            }
        }
    }
    handleChangeapproverList = (value) => {
        // let tempValue = [value][0];
        // this.setState({
        //     selectApprover: tempValue
        // })
        if (value != "") {
            console.log(`selected ${value}`);
            var array = [...this.state.selectApprover];
            var index = array.indexOf(value)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selectApprover: array });
            }
        } else {
            this.setState({ selectApprover: [] });
        }
    }
    render() {
        const { match } = this.props
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalConfirm}
                    onCancel={this.handleCancel}
                    closable={false}
                    // title="นโยบายความคุ้มครองส่วนบุคคล "
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOk}>
                            ยอมรับ</Button>,
                    ]}
                >
                    <div style={{ textAlign: 'center' }}>
                        <p style={{ fontSize: "18px" }}>
                            คุณต้องการส่งคำขออนุมัติการประชุม<br />
                            ใช่หรือไม่
                        </p>
                    </div>
                </Modal>
                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalSelectAprover}
                    onCancel={this.handleCancel}
                    closable={false}
                    title="รายชื่อผู้อนุมัติการประชุม "
                    footer={[
                        <Button key="back" className={'btn-modal-cancle'} onClick={this.handleCancel}>
                            ยกเลิก</Button>,
                        <Button key="submit" className={'btn-modal-confirm'} onClick={this.handleOkapproverList}>
                            เสร็จสิ้น</Button>,
                    ]}
                >
                    <div style={{ height: 400, width: 450, overflow: "auto" }}>
                        <Row gutter={16} className={'pt-2'}>
                            <Col xs={24} className={'py-1'}>
                                <Input
                                    placeholder="ค้นหา"
                                />
                            </Col>
                            {this.state.approverList.map((user, i) => {
                                return (
                                    <Col xs={24} className={'py-1'}>
                                        <Checkbox onChange={this.onCheckAddInternal} value={user.id}> <p style={{ fontSize: "14px", display: "inline" }}>{user.name}</p></Checkbox>
                                    </Col>
                                )
                            })}
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className={'meeting-management-modal'}
                    visible={this.state.showModalSuccess}
                    onCancel={this.handleCancel}
                    footer={null}
                    closable={false}
                >
                    <div className={'py-5'} style={{ textAlign: 'center', color: "#178991" }}>
                        <Icon style={{ fontSize: "70px", paddingBottom: "30px" }} type="check-circle" />
                        <p style={{ fontSize: "20px" }}>
                            {this.state.textModalSuccess}
                        </p>
                    </div>
                </Modal>
                <div className="card-container meeting-management" id="form-meeting">
                    <div className="p-5 card-bg-white">
                        <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                            {this.state.idMeeting ?
                                <Col xs={19} >
                                    <Link
                                        to={{
                                            pathname: `/meetingmanagement/CreateMeeting/`,
                                            search: "create",
                                        }}>
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> รายละเอียดการประชุมฉบับร่าง</p>
                                    </Link>
                                </Col>
                                :
                                <Col xs={19} >
                                    <Link
                                        to={{
                                            pathname: `/meetingmanagement/CreateMeeting/`,
                                            search: "edit",
                                        }}>
                                        <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> สร้างการประชุมใหม่</p>
                                    </Link>
                                </Col>
                            }
                            <Col xs={5} align={"right"} >
                                {this.state.idMeeting ?
                                    < Button onClick={this.openModalDeleteMeeting} type="link">
                                        <Icon type="delete" style={{ fontSize: "20px", color: "#666666" }} />
                                    </Button>
                                    :
                                    <></>
                                }
                            </Col>
                        </Row>
                        <Row className="px-5 py-3" gutter={16} type="flex" justify="center" align="top">
                            <Col xs={24} md={16}>
                                <p style={{ fontSize: "18px" }} className={'color-text-red'}>ขออนุมัติการประชุม</p>
                            </Col>
                            <Col xs={12} md={6}>
                                <p className={'color-text-gray'}>เข้าร่วมประชุม</p>
                            </Col>
                            <Col xs={12} md={2} type="flex" justify="center">
                                <Switch />
                            </Col>
                            <Col xs={24} md={16}>
                                <Form.Item label={"หัวข้อการประชุม"} className="mb-0">
                                    <Input
                                        placeholder="กรอกหัวข้อการประชุม"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="วันที่ออกเอกสาร" className="mb-0">
                                    <DatePicker
                                        defaultValue={moment(moment().format("DD-MM-YYYY"), dateFormat)}
                                        format={dateFormat}
                                        className="w-100"
                                        placeholder="เลือกวันที่"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={16}>
                                <Form.Item label={"ผู้อนุมัติ"} className="mb-0 ">
                                    <Select
                                        mode="multiple"
                                        allowClear
                                        disabled
                                        style={{ width: '100%' }}
                                        placeholder="Please select"
                                        value={this.state.selectApprover}
                                        onChange={this.handleChangeapproverList}
                                    >
                                        {this.state.approverList.map((user, i) => {
                                            return (
                                                <Option key={user.id}>{user.name}</Option>
                                            )
                                        })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label=" " className="mb-0">
                                    <Button className={'button-meeting-select w-100'} onClick={this.handleOpen}>
                                        เลือกผู้อนุมัติการประชุม</Button>
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item label={"สถานที่การประชุม"} className="mb-0">
                                    <Input
                                        placeholder="ระบุสถานที่การประชุม"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Item label="เริ่มต้น" className="mb-0">
                                    <DatePicker
                                        defaultValue={moment(moment().format("DD-MM-YYYY"), dateFormat)}
                                        format={dateFormat}
                                        className="w-100"
                                        placeholder="เลือกวันที่"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Item label=" " className="mb-0">
                                    <TimePicker
                                        defaultValue={moment('12:00', timeFormat)}
                                        format={timeFormat}
                                        className="w-100"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Item label="สิ้นสุด" className="mb-0">
                                    <DatePicker
                                        defaultValue={moment(moment().format("DD-MM-YYYY"), dateFormat)}
                                        format={dateFormat}
                                        className="w-100"
                                        placeholder="เลือกวันที่"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={12} md={6}>
                                <Form.Item label=" " className="mb-0">
                                    <TimePicker
                                        defaultValue={moment('12:00', timeFormat)}
                                        format={timeFormat}
                                        className="w-100"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item label="รายละเอียด" className="mb-3">
                                    <TextArea
                                        rows={8}
                                        placeholder="กรอกรายละเอียด"
                                    />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <label for={"input-file"} class="">
                                    <p style={{ color: "#3C8BE9" }}><Icon type="paper-clip" />แนบไฟล์</p>
                                </label>
                                <input
                                    id={"input-file"}
                                    className="input-file"
                                    type="file"
                                    accept="file_extension"
                                />
                            </Col>
                            <Col xs={24} md={12} lg={{ span: 5, offset: 3 }} xl={{ span: 4, offset: 9}}>
                                <Link
                                    to={{
                                        pathname: '/meetingmanagement/CreateMeetingFormWithApprove/',
                                    }}>
                                    <Button className={'button-meeting-transparent w-100'}>
                                        ยกเลิก</Button>
                                </Link>
                            </Col>
                            <Col xs={24} md={12} lg={{ span: 5 }} xl={4}>
                                <Button className={'button-meeting-transparent w-100'}>
                                    บันทึกฉบับร่าง</Button>
                            </Col>
                            <Col xs={24} md={12} lg={11} xl={7}>
                                <Button className={'button-meeting w-100'} onClick={this.sentApprover}>
                                    ส่งคำขออนุมัติและส่งคำเชิญประชุม</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Container>
        )
    }
}

CreateMeetingFormWithApprove.propTypes = {
    //
}

export default withApollo(CreateMeetingFormWithApprove)